import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { RegionSummary } from '@/types/serviceArea'

import { MOCK_REGION_LIST } from './mocks'

/**
 * 광역권역 리스트 조회.
 *
 * 응답: 광역권역(서울/경기/인천/경상 등)의 한글 이름과 하위 subRegionList,
 * 그리고 광역권역 레벨 isFullCoverage를 받는다. Tabs 동적 렌더에 사용.
 */
export const apiGetRegionList = async (): Promise<RegionSummary[]> => {
  if (IS_MOCK) {
    await mockDelay()
    return MOCK_REGION_LIST
  }
  return await api.get<RegionSummary[]>('/service-area/region')
}
